module.exports = __webpack_public_path__ + "static/vkontakte-50b8ae16adc9c82740bf188206cb5197.png";